


































import { Site } from "@/shared/Site";
import $store from "@/store/store";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import VendeurChooser from "@/components/vendeurChooser.vue";
import { LieuRapport } from "@/shared/Rapport";
import CaisseChooser from "@/components/caisseChooser.vue";

@Component({
  components: { CaisseChooser, VendeurChooser },
})
export default class LocalChooser extends mixins(MobileMixin) {
  public searchTxt: string = "";
  public toggle = "vendeurs";
  @Prop({ default: "site" }) public site!: Site;
  @Prop() public lieu!: LieuRapport;

  /*
   * methode de mise a jour de la liste des caisses depuis le composant vers la page qui l'affiche
   */
  public updateCaisses(listeCaisses: any) {
    this.$emit("updateCaisses", listeCaisses);
  }

  public selectVendeur(vendeur: string) {
    this.$emit("updateVendeur", vendeur);
  }

  public mounted() {
    // console.log(this.lieu);
  }

  get monrapport(): LieuRapport {
    return this.lieu;
  }
}
